import React from "react";
import { Link } from "react-router-dom";
import Meta from "../components/Meta";
import "./NotFoundScreen.css";

export default function NotFoundScreen() {
  return (
    <main className="not-found">
      <Meta title="Page Not Found | Academy Costumes London" />

      <span className="not-found__code" aria-hidden="true">
        404
      </span>

      <h1 className="not-found__title">Page not found</h1>

      <p className="not-found__text">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <Link to="/" className="not-found__link">
        Back to home
      </Link>
    </main>
  );
}
